<script>
import ExerciseDetail from '@components/exercise/exercise-detail.vue';
import ExerciseList from '@components/exercise/exercise-list.vue';
import ExerciseStepForm from '@components/forms/exercise-step-form.vue';
import CircuitForm from '@components/forms/circuit-form.vue';
import WorkoutDetail from '@components/workout/workout-detail.vue';
import WorkoutList from '@components/workout/workout-list.vue';
import { circuitModelMixin } from '@mixins/models/circuit-model-mixin';
import {
  adminPanelComputed,
  adminPanelMethods,
  circuitComputed,
  circuitMethods,
  exerciseComputed,
  exerciseMethods,
  workoutComputed,
  workoutMethods,
} from '@state/helpers';

export default {
  components: {
    CircuitForm,
    ExerciseDetail,
    ExerciseList,
    ExerciseStepForm,
    WorkoutDetail,
    WorkoutList,
  },
  props: {},
  mixins: [circuitModelMixin],
  data() {
    return {};
  },
  computed: {
    ...adminPanelComputed,
    ...circuitComputed,
    ...exerciseComputed,
    ...workoutComputed,
    newCircuitIndex() {
      return this.selectedWorkout &&
        this.selectedWorkout.circuits &&
        this.selectedWorkout.circuits.length > 0
        ? this.selectedWorkout.circuits.length - 1
        : 0;
    },
  },
  mounted() {},
  methods: {
    ...adminPanelMethods,
    ...circuitMethods,
    ...exerciseMethods,
    ...workoutMethods,
    onSelectExerciseItem(exercise) {
      if (this.panelContent.data.componentLeft.name === 'ExerciseDetail') {
        this.setSelectedAltExercise(exercise);
        this.setHidePanelContentDetail();
      } else {
        const selectedIndex = this.panelContent.data.componentRight
          .selectedCircuitIndex;
        this.setAddWorkoutCircuitExercise({
          exercise: exercise,
          defaultSet: [this.getCircuitExerciseSetModel()],
          circuitIndex: selectedIndex >= 0 ? selectedIndex : this.newCircuitIndex,
        });
        this.setHidePanelContentDetail();
      }
    },
    onSelectCircuitItem(circuit) {
      this.setAddWorkoutCircuit(circuit);
      this.setSelectedCircuit(null);
      this.setHidePanelContentDetail();
    },
    onSelectLibraryWorkout(libraryWorkout) {
      this.setIsLibraryWorkout(true);
      this.setInitialLibraryWorkout(libraryWorkout);
      this.setHidePanelContentDetail();
    },
  },
};
</script>

<template>
  <div class="split-pane">
    <div class="pane-left">
      <component
        v-if="panelContent"
        :is="panelContent.data.componentLeft.name"
        :content="panelContent"
        :workout="panelContent.data.componentLeft.selectedWorkout"
        :exercise="panelContent.data.componentLeft.selectedExercise"
        :inPanel="panelContent.data.componentLeft.inPanel"
      />
    </div>
    <div class="pane-right">
      <component
        v-if="panelContent"
        :is="panelContent.data.componentRight.name"
        :content="panelContent"
        :circuits="panelContent.data.componentRight.circuits"
        :hideDescription="panelContent.data.componentRight.hideDescription"
        :showExerciseFilters="panelContent.data.componentRight.showExerciseFilters"
        :showWorkoutFilters="panelContent.data.componentRight.showWorkoutFilters"
        :inPanel="true"
        :hideBaseCardHeader="true"
        @select-exercise-item="onSelectExerciseItem"
        @select-circuit-item="onSelectCircuitItem"
        @select-library-workout="onSelectLibraryWorkout"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';
// stylelint-disable selector-pseudo-element-no-unknown

.split-pane {
  display: flex;
  overflow-y: hidden;

  .pane-left,
  .pane-right {
    flex: 1;
    height: 100vh;
    overflow-y: scroll;
    padding-bottom: 0.8rem;
    position: fixed;
  }

  .pane-left {
    border-right: 2px solid $color-light-gray;
    right: 28%;
    width: 72%;

    @include media('xxxl', null) {
      right: 35%;
      width: 65%;
    }
  }

  .pane-right {
    left: 72%;
    width: 28%;

    @include media('xxxl', null) {
      left: 65%;
      width: 35%;
    }

    ::v-deep {
      .select-existing-circuit {
        padding: 0;

        @include media('xxxl', null) {
          padding: 0 3rem;
        }
      }

      .circuit-list {
        .search-input-wrapper {
          padding-left: 0;
          width: 100%;

          @include media('xxxl', null) {
            padding-left: 3rem;
            width: 80%;
          }
        }

        .list-minimal-item {
          padding-left: 2rem;

          @include media('xxxl', null) {
            padding-left: 3.6rem;
          }
        }
      }

      .panel-footer {
        bottom: 10rem;
      }

      .exercise-step-form {
        padding: 3.2rem 3rem;

        .panel-footer {
          bottom: 1rem;
          width: 31%;
        }
      }
    }
  }

  ::v-deep {
    .exercise-filters,
    .workout-filters {
      padding: 2rem 2rem 0;

      .search-input-wrapper {
        width: 100%;
      }

      .col-3 {
        -webkit-box-flex: 0;
        flex: 0 0 50%;
        max-width: 50%;
      }
    }

    .exercise-item {
      padding-left: 2rem;
    }

    .exercise-title h3,
    .list-item-title h3 {
      font-size: 1.8rem;
    }
  }
}
</style>
